(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("textarea[data-v-6a49fbc7]{min-width:0;background:none;outline:none}")),document.head.appendChild(e)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
import { useTextareaAutosize as M } from "@vueuse/core";
import { defineComponent as j, reactive as D, ref as b, computed as i, toRef as K, resolveComponent as u, openBlock as v, createElementBlock as F, normalizeClass as R, createBlock as T, withCtx as l, renderSlot as h, createTextVNode as s, toDisplayString as n, createCommentVNode as N, createVNode as q, withDirectives as S, createElementVNode as U, mergeProps as G, vModelText as J, createSlots as E, vShow as H } from "vue";
import { useIdAttribute as Q, useControlAttributes as W, useValidationAttributes as X, useProxyModelValue as Y } from "@onereach/ui-components-common/hooks";
import { isObject as m } from "@onereach/ui-components-common/utils";
import { O as Z } from "./OrError-B5ihH6-3.mjs";
import { O as x } from "./OrHint-NvbZyURY.mjs";
import { O as _ } from "./OrInputBox-6ciokFdU.mjs";
import { b as O, a as ee } from "./OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs";
import { O as oe } from "./OrLabel-DssheqEn.mjs";
import { _ as te } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const re = [
  // Layout
  "layout-column",
  // Spacing
  "gap-xs"
], ae = [
  // Box
  "w-full",
  // Typography
  "typography-inherit",
  // Theme (placeholder)
  "placeholder:theme-foreground-outline",
  "dark:placeholder:theme-foreground-outline-dark"
], le = {
  [O.M]: [
    // Spacing
    "!mx-0",
    "px-md md:px-sm+",
    "py-sm+* md:py-sm*"
  ],
  [O.S]: [
    // Spacing
    "!mx-0",
    "px-md md:px-sm+",
    "py-sm*"
  ]
}, ne = j({
  name: "OrTextarea",
  components: {
    OrError: Z,
    OrHint: x,
    OrInputBox: _,
    OrLabel: oe
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    variant: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: () => O.M
    },
    rows: {
      type: [Number, Object],
      default: 2
    },
    label: {
      type: String,
      default: void 0
    },
    placeholder: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    error: {
      type: [String, Boolean],
      default: void 0
    },
    required: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "input",
    "keydown",
    "keyup",
    "focus",
    "blur"
  ],
  expose: [
    "root",
    "focus",
    "blur"
  ],
  setup(e, o) {
    const p = D({
      id: Q(),
      ...W(),
      ...X()
    }), w = b(), $ = i(() => [
      "or-textarea-v3",
      ...re,
      ...e.variant === ee.Embedded ? ["grow"] : []
    ]), a = b(), f = i(() => [
      ...ae,
      ...le[e.size],
      ...m(e.rows) ? ["resize-none"] : []
    ]), y = i(() => {
      var r, V, B, k, C, c;
      if (a.value) {
        const z = Number(((V = (r = getComputedStyle(a.value).getPropertyValue("padding-top").match(/^(?<value>\d+)px$/)) == null ? void 0 : r.groups) == null ? void 0 : V.value) || 0), I = Number(((k = (B = getComputedStyle(a.value).getPropertyValue("padding-bottom").match(/^(?<value>\d+)px$/)) == null ? void 0 : B.groups) == null ? void 0 : k.value) || 0), L = Number(((c = (C = getComputedStyle(a.value).getPropertyValue("line-height").match(/^(?<value>\d+)px$/)) == null ? void 0 : C.groups) == null ? void 0 : c.value) || 0);
        return {
          minHeight: `${z + I + (m(e.rows) ? e.rows.min : e.rows) * L}px`,
          maxHeight: m(e.rows) && e.rows.max ? `${z + I + e.rows.max * L}px` : void 0
        };
      }
      return {};
    }), d = Y(K(e, "modelValue"), o.emit, { defaultValue: b("") }), g = i(() => {
      var r;
      return ((r = d.value) == null ? void 0 : r.toString().length) ?? 0;
    }), t = i(() => p.maxlength);
    function P() {
      var r;
      (r = a.value) == null || r.focus();
    }
    function A() {
      var r;
      (r = a.value) == null || r.blur();
    }
    return m(e.rows) && M({
      element: a,
      input: d
    }), {
      attributes: p,
      root: w,
      rootStyles: $,
      control: a,
      controlStyles: f,
      controlInlineStyles: y,
      model: d,
      length: g,
      maxLength: t,
      focus: P,
      blur: A
    };
  }
}), de = ["name", "rows", "autocomplete", "placeholder", "required", "readonly", "disabled"];
function ie(e, o, p, w, $, a) {
  const f = u("OrLabel"), y = u("OrInputBox"), d = u("OrHint"), g = u("OrError");
  return v(), F("div", {
    ref: "root",
    class: R(e.rootStyles)
  }, [
    e.$slots.label || e.$slots.addon || e.label ? (v(), T(f, {
      key: 0,
      "control-id": e.attributes.id,
      variant: "input",
      required: e.required,
      disabled: e.disabled
    }, {
      addon: l(() => [
        h(e.$slots, "addon", {}, void 0, !0)
      ]),
      default: l(() => [
        h(e.$slots, "label", {}, () => [
          s(n(e.label), 1)
        ], !0)
      ]),
      _: 3
    }, 8, ["control-id", "required", "disabled"])) : N("", !0),
    q(y, {
      variant: e.variant,
      size: e.size,
      invalid: !!e.error,
      readonly: e.readonly,
      disabled: e.disabled
    }, {
      default: l(() => [
        S(U("textarea", G({ ref: "control" }, e.attributes, {
          "onUpdate:modelValue": o[0] || (o[0] = (t) => e.model = t),
          class: e.controlStyles,
          style: e.controlInlineStyles,
          name: e.name,
          rows: e.rows,
          autocomplete: e.autocomplete,
          placeholder: e.placeholder,
          required: e.required,
          readonly: e.readonly,
          disabled: e.disabled,
          onInput: o[1] || (o[1] = (t) => e.$emit("input", t)),
          onKeydown: o[2] || (o[2] = (t) => e.$emit("keydown", t)),
          onKeyup: o[3] || (o[3] = (t) => e.$emit("keyup", t)),
          onFocus: o[4] || (o[4] = (t) => e.$emit("focus", t)),
          onBlur: o[5] || (o[5] = (t) => e.$emit("blur", t))
        }), null, 16, de), [
          [J, e.model]
        ])
      ]),
      _: 1
    }, 8, ["variant", "size", "invalid", "readonly", "disabled"]),
    e.$slots.hint || e.hint || e.maxLength ? S((v(), T(d, {
      key: 1,
      disabled: e.disabled
    }, E({
      default: l(() => [
        h(e.$slots, "hint", {}, () => [
          s(n(e.hint), 1)
        ], !0)
      ]),
      _: 2
    }, [
      e.maxLength ? {
        name: "addon",
        fn: l(() => [
          s(n(e.length) + " / " + n(e.maxLength), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["disabled"])), [
      [H, !e.error]
    ]) : N("", !0),
    S(q(g, { disabled: e.disabled }, E({
      default: l(() => [
        s(n(e.error) + " ", 1)
      ]),
      _: 2
    }, [
      e.maxLength ? {
        name: "addon",
        fn: l(() => [
          s(n(e.length) + " / " + n(e.maxLength), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["disabled"]), [
      [H, typeof e.error == "string" && e.error.length > 0]
    ])
  ], 2);
}
const Se = /* @__PURE__ */ te(ne, [["render", ie], ["__scopeId", "data-v-6a49fbc7"]]);
export {
  Se as O
};
//# sourceMappingURL=OrTextarea-VEuq5855.mjs.map
